export default __webpack_public_path__ + "static/media/check-circle.8a39e6d5.png";